var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',[_c('el-main',[_c('page-sentry',{on:{"allowed":_vm.handleAllowed,"disallowed":_vm.handleDisallowed}},[_c('template',{slot:"allowed"},[_c('page-upload',{attrs:{"accessKey":_vm.accessKey,"uploadInfo":_vm.uploadInfo}})],1),_vm._v(" "),_c('template',{slot:"disallowed"},[_c('page-forbidden')],1)],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-928e81f2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 